//! 设置各个OEM APP的名称
const OEM_APP_ENUM = {
    COMFORT_HOME: "comfortHome",
    OMNIA_SMART: "OMNIA_Smart",
    IDOLA_SMART: "IDOLA_Smart"
};

/*
!用哪一个模板渲染, 有以下的选项:
*/
export const RENDER_TEMPLATE_ENUM = {
    JSON_BY_HUMAN: "RenderJsonByHuman", //之前杨伟胜用json的方式对应的模板
    HTML_BY_DOCPE: "RenderHtmlByDocpe", //通过 http://www.docpe.com/word/word-to-html.aspx 转换为 html的方式对应的模板

    HTML_BY_MAMMOTH: "RenderHtmlByMammoth" //通过  https://github.com/mwilliamson/mammoth.js  转换为 html的方式对应的模板
};

//! 设置各个OEM APP支持的版本号
const versionList = [
    {
        // num: 3,
        data: "2020xxxx",
        version: "v3",
        desc: "这个不知道是什么时候的版本",

        renderTemplate: RENDER_TEMPLATE_ENUM.JSON_BY_HUMAN,
        show: false //!暂时不显示
    },
    {
        // num: 3,
        data: "20201220", //在版本列表显示的信息
        version: "v3.20.1220", //目录名称，和/static/langPackzh对应
        desc: "comfortHome V3版本;之前杨伟胜用json的方案", //描述

        renderTemplate: RENDER_TEMPLATE_ENUM.JSON_BY_HUMAN, //渲染的模板,模板的类型决定了数据源的扩展名
        show: process.env.OEM_APP === OEM_APP_ENUM.COMFORT_HOME //这里指定那些app（通过set OEM_APP="OMNIA_Smart"设置）可以显示这个版本
    },
    {
        // num: 4,
        data: "20210430",
        version: "v4.21.0430",
        desc:
            "comfortHome V4版本;梁德锋第一次接手用html的方案(http://www.docpe.com/word/word-to-html.aspx)",
        renderTemplate: RENDER_TEMPLATE_ENUM.HTML_BY_DOCPE,
        show: process.env.OEM_APP === OEM_APP_ENUM.COMFORT_HOME
    },
    {
        data: "20220928",
        version: "v1.22.0928",
        desc: `为大客户 Ferroli 定制App(OMNIA Smart)的隐私条款;
        为大客户 Lamborghini 定制App(IDOLA Smart)的隐私条款;梁德锋第二次接手用html的方案(mammoth.js)`,
        renderTemplate: RENDER_TEMPLATE_ENUM.HTML_BY_MAMMOTH,
        show:
            process.env.OEM_APP === OEM_APP_ENUM.OMNIA_SMART ||
            process.env.OEM_APP === OEM_APP_ENUM.IDOLA_SMART
    }
];

//! 设置各个OEM APP默认的版本
export const defaultVersion = {
    [OEM_APP_ENUM.COMFORT_HOME]: "v4.21.0430",
    [OEM_APP_ENUM.OMNIA_SMART]: "v1.22.0928",
    [OEM_APP_ENUM.IDOLA_SMART]: "v1.22.0928"
}[process.env.OEM_APP];

//! 设置各个OEM APP部署正式环境时的目录路径
export const urlPath = {
    [OEM_APP_ENUM.COMFORT_HOME]: `/privacy/`,
    [OEM_APP_ENUM.OMNIA_SMART]: `/ferroli-lamborghini_privacy/`,
    [OEM_APP_ENUM.IDOLA_SMART]: `/ferroli-lamborghini_privacy/`
}[process.env.OEM_APP];

// export const numMap = {};
export const dataMap = {};
export const versionMap = {};
export const versionOption = [];
export const dataOption = [];

versionList
    .filter(item => item.show)
    .forEach(item => {
        // numMap[item.num] = item;
        dataMap[item.data] = item;
        versionMap[item.version] = item;

        versionOption.push(item.version);
        dataOption.push(item.data);
    });



// WEBPACK FOOTER //
// ./src/utils/const/privacy.js